let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2HRN3"), load("hZSgn"), load("lnKog")]).then(() => parcelRequire('2mcHd'));